import CaseNoteReportsContainer from "./CaseNoteReports.container";
export default CaseNoteReportsContainer;